export const numDecimales = 6;
export const numDecimalesDescuento = 2;

//export const apiKey = "HxmNHprKq2S8Kx0gK6jf";
export const apiKey = window._env_.API_KEY
//export const subscriptionKey = "74364d0d5bc24d57be8a80aa616bf47f";
export const subscriptionKey = window._env_.APIKEY_PAC;

export const bookApis = {
  auth: {
    get_all_permissons: (idPerfil, codigoSistema) =>
      `/admin/permisos/${idPerfil}/${codigoSistema}`,
  },
};
